<template>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('ajoutEditContrat.commentaire.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-12">
            <b-field :label="$t('ajoutEditContrat.commentaire.commentaire')">
              <b-input v-model="contrat.commentaire" type="textarea" rows="4">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BauxContratEditCommentaire',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
